import { QuickLinksSection } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/QuickLinksCard/QuickLinksSection.tsx';
import { useVehicleQuickLinks } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestmentVehicleDetails/components/VehicleQuickLinksCard/useVehicleQuickLinks.ts';

interface Props {
	dealId: string;
	mipId: string;
	personId: string;
}

export const VehicleQuickLinksCard = ({ dealId, mipId, personId }: Props) => {
	const { links, isLoading, isError } = useVehicleQuickLinks({ dealId, mipId, personId });

	return <QuickLinksSection links={links} isLoading={isLoading} isError={isError} />;
};
